<template>
	<v-dialog
		v-model="dialog"
		fullscreen
		no-click-animation
		persistent
	>
		<v-app-bar dark color="primary" dense>
			<v-spacer></v-spacer>
			<v-toolbar-title>
				<v-img
					:src="require('@/assets/img/cronaportal-side-white.png')"
					:lazy-src="require('@/assets/img/cronaportal-side-white.png')"
					contain
					width="200"
				/>
			</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-app-bar>

		<v-card class="fill-height">
			<v-card-text class="fill-height">
				<v-container fluid class="fill-height">
					<v-row no-gutters align="center" justify="center">

						<v-col cols="12" class="text-center">
							<Title bold>{{$t('MobileApp.UpdateDialog.Title')}}</Title>
							<v-icon color="accent" :size="100">mdi-update</v-icon>
						</v-col>

						<v-col cols="12" class="text-center mt-5">
							<SubTitle>{{description}}</SubTitle>
						</v-col>

						<v-col cols="12" class="text-center mt-5">
							<MobileStoreButtons :forceShow="true"/>
						</v-col>

						<v-col cols="12" class="text-center mt-10">
							<p><b>{{alternativeDescription}}</b></p>
							<v-btn v-if="showButton" color="secondary" :href="linkCronaPortal">
								{{$t('MobileApp.UpdateDialog.Alternative.Action')}}
							</v-btn>
							<p v-else>{{$t('MobileApp.UpdateDialog.Alternative.URL')}}</p>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
		
	</v-dialog>
	
</template>

<script>
import Title              from '../typography/Title.vue';
import SubTitle           from '../typography/SubTitle.vue';
import MobileStoreButtons from '../MobileStoreButtons.vue';

export default {
	name: 'MobileAppUpdateDialog',
	
	components: {SubTitle, MobileStoreButtons, Title},

	data: () => ({
		dialog:          true,
		version:         '3.0.9',
		linkCronaPortal: 'https://portal.crona.se',
	}),

	computed: {
		description() {
			return this.$t('MobileApp.UpdateDialog.Description', {version: this.version});
		},

		store() {
			let store = '';

			if(this.isDeviceAndroid) {
				store = this.$t('MobileApp.UpdateDialog.Alternative.Playstore');
			}

			if(this.isDeviceIOS) {
				store = this.$t('MobileApp.UpdateDialog.Alternative.Appstore');
			}

			return store;
		},

		alternativeDescription() {
			return this.$t('MobileApp.UpdateDialog.Alternative.Description', {
				version: this.version,
				store:   this.store,
			});
		},

		showButton() {
			// return this.isDeviceAndroid || (
			// 	this.isDeviceIOS &&
			// 	window.MobileApp.Info &&
			// 	parseInt(window.MobileApp.Info.Version) >= 309010
			// );
			return false;
		},
	},
}
</script>

<style scoped>

</style>
